import type { CreateTagInput, Tag } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: () => api.get<Tag[]>('/api/tags'),
  })
}

export function useCreateTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTagInput) => api.post('/api/tags', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  })
}
